const utils = require('./utils');

module.exports = {
  transitionM2: () => {
    /**
     * @param  {Node} elm - Element to be transitioned
     * @param  {boolean} expand - Boolean to hide/show the element
     * @param  {Node} group - Group where only 1 element is allowed to be shown at once
     */
    $('body').on('transition-m2', (event, elm, expand, group) => {
      const element = elm;
      if (element.classList.contains('transition-m2')) {
        if (expand) {
          element.classList.add('transition-m2--expanded');
        } else {
          element.classList.remove('transition-m2--expanded');
        }

        element.style.maxHeight = expand ? `${utils.getHeight(element)}px` : 0;

        if (typeof group !== 'undefined') {
          const transitionElements = group.querySelectorAll('.transition-m2');
          for (let i = 0; i < transitionElements.length; i++) {
            const transitionElement = transitionElements[i];
            if (transitionElement !== element) {
              transitionElement.style.maxHeight = 0;
            }
          }
        }
      }
    });
  },
};
